<template>
  <settings-group-item
    class="review-members-setting"
    label="Reviewers"
    description="Users with read/write access to the review"
  >
    <div class="d-flex flex-column justify-center">
      <review-member-management
        :open.sync="popupOpen"
        :review-members="reviewers"
        :min-width="500"
      >
        <template #popup>
          <invite-user-popup
            :researcher-search-input.sync="searchInput"
            :researcher-search-results="researcherSearchResults"
            :lead-reviewer="leadReviewer"
            :reviewers="reviewers"
            :invites="invites"
            :editable="editable"
            v-on="$listeners"
            @close="popupOpen = false"
          />
        </template>
      </review-member-management>
      <pending-invite-menu
        v-if="invites.length"
        class="mt-2"
        :invites="invites"
        v-on="$listeners"
      />
    </div>
  </settings-group-item>
</template>

<script>
import SettingsGroupItem from './SettingsGroupItem';
import ReviewMemberManagement from './ReviewMemberManagement';
import InviteUserPopup from './InviteUserPopup';
import PendingInviteMenu from './PendingInviteMenu';
import {
  ReviewMember,
  ReviewMemberInvite,
  Researcher,
} from '@/models';
import { typeHelpers } from '@/modules';

export default {
  name: 'ReviewMembersSetting',
  components: {
    SettingsGroupItem,
    ReviewMemberManagement,
    InviteUserPopup,
    PendingInviteMenu,
  },
  props: {
    leadReviewer: {
      type: ReviewMember,
      required: true,
    },
    reviewers: {
      type: Array,
      default: () => [],
      validator: (field) =>
        typeHelpers.isArrayOfType(field, ReviewMember),
    },
    invites: {
      type: Array,
      default: () => [],
      validator: (field) =>
        typeHelpers.isArrayOfType(field, ReviewMemberInvite),
    },
    researcherSearchInput: {
      type: String,
      default: null,
    },
    researcherSearchResults: {
      type: Array,
      default: () => [],
      validator: (val) => typeHelpers.isArrayOfType(val, Researcher),
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  emits: [
    'update:researcherSearchInput',
    'invite',
    'invite-by-email',
    'delete',
    'revoke-invite',
  ],
  data: () => ({ popupOpen: false }),
  computed: {
    searchInput: {
      get: function () {
        return this.researcherSearchInput;
      },
      set: function (value) {
        this.$emit('update:researcherSearchInput', value);
      },
    },
  },
  watch: {
    popupOpen: function (value) {
      if (value) {
        this.searchInput = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.review-members-setting {
  // Prevent the avatar cluster from overlapping popups.
  z-index: 0;
}
</style>
